import {
  AudioTags,
  tTaskAudioManagerItems
} from 'students/views/shared/bundles/audio/models';

import mp3MatchCorrect from 'students/views/shared/assets/match_correct.mp3';
import mp3MatchIncorrect from 'students/views/shared/assets/match_incorrect.mp3';

/**
 * Namespaced per surface: the audio repository is app-wide, so two surfaces
 * registering the same bare id shadow each other (see `TaskAudioManager.addUnique`).
 */
export const GameAudioIds = {
  correct: 'game:common:correct',
  incorrect: 'game:common:incorrect'
} as const;

/** Registered once per session (`caching: true`) — see `useGameAudioPlayer`. */
export const gameSoundEffectAudioItems: tTaskAudioManagerItems = [
  {
    id: GameAudioIds.correct,
    tags: [AudioTags.SoundEffects],
    src: mp3MatchCorrect,
    html5: false,
    preload: true,
    caching: true,
    volume: 0.1
  },
  {
    id: GameAudioIds.incorrect,
    tags: [AudioTags.SoundEffects],
    src: mp3MatchIncorrect,
    html5: false,
    preload: true,
    caching: true,
    volume: 0.1
  }
];
